import {
  Box,
  Text,
  HStack,
  Image as ChakraImage,
  Button,
} from "@chakra-ui/react";
import smrImage8 from "@/assets/images/smr_img8.png";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { refreshGenCoin } from "@/store/actions";
import { useEffect } from "react";
import { selectMode, updateDesign } from "@/reducer/modeslice";

const SmrImgNum = () => {
  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);
  const imgNums: number[] = [1, 2, 3, 4];

  const handleChangeImgNum = (num: number) => {
    let curnum = num;
    if (num < 1) {
      curnum = 1;
    }
    const newdesign = { ...design, n_iter: curnum };
    dispatch(updateDesign(newdesign));
  };

  useEffect(()=>{
    dispatch(refreshGenCoin())
  },[dispatch,design.n_iter])

  return (
    <Box
      background="linear-gradient(40.59deg, #496AE1 72.71%, #172147 86.65%)"
      borderRadius="10px"
      p="1px"
      mt="20px"
    >
      <Box
        p="20px"
        borderRadius="10px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <HStack>
          <ChakraImage src={smrImage8} />
          <Text fontSize={"16px"} color="#FFFFFF">
            出图数量
          </Text>
        </HStack>

        <Box mt="20px">
          <HStack>
            {imgNums.map((item) => (
              <Button
                key={item}
                w="67px"
                h="28px"
                bg={item === design.n_iter ? "none" : "#1C2337"}
                border={item === design.n_iter ? "1px solid #496AE1" : "none"}
                borderRadius={"10px"}
                color={"#FFFFFF"}
                _hover={{
                  bg: "none",
                  border: "1px solid #496AE1",
                }}
                onClick={() => handleChangeImgNum(item)}
              >
                {item}
              </Button>
            ))}
          </HStack>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrImgNum;
